export default function user(
	state = { login: false, user: null, redirect: false, redirectToSignUp: false},
	action
) {
	var userCopy = Object.assign({}, state);
	if (action.type === "USERS_LOGIN_SUCCESS") {
    userCopy.redirect = true;
    userCopy.login = true;
    userCopy.token = action.token;
    userCopy.user = action.user
    return userCopy;

}

 else if (action.type === "dispatchUser") {
	userCopy.user = action.user;
	userCopy.redirect = true;
	userCopy.login = true;
	return userCopy;

}
else if (action.type === "disconnect") {
 userCopy.user = null;
 userCopy.redirect = false
 userCopy.redirectToSignUp = false;
 userCopy.login = false;
 return userCopy;

}
else if (action.type === "USERS_REDIRECT_SIGNUP") {
 userCopy.user = action.user;
 userCopy.redirectToSignUp = true;
 userCopy.login = true;
 //console.log("dans le reducer on a : ", userCopy)
 return userCopy;

}
else if (action.type === "USERS_SIGNUP_SUCCESS") {
 userCopy.redirectToSignUp = false;
 return userCopy;
}

	 else {
		return state;
	}
}
